"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDownloadingModelProgress = void 0;
const useOdrModels_1 = require("./useOdrModels");
function useDownloadingModelProgress(identifier, diversityKey) {
    var _a;
    const odrModels = (0, useOdrModels_1.useOdrModels)();
    if (!odrModels) {
        return 0;
    }
    const modelState = odrModels.find(state => state.identifier === identifier);
    if (!modelState) {
        return 0;
    }
    const diversityResourceState = (_a = modelState.diversityResourcesState) === null || _a === void 0 ? void 0 : _a.find(state => state.diversityKey === diversityKey);
    let fractionCompleted = diversityResourceState
        ? diversityResourceState.isCached
            ? 1
            : diversityResourceState.progress
        : modelState.isCached
            ? 1
            : modelState.progress;
    if (+fractionCompleted < 0) {
        fractionCompleted = 0;
    }
    else if (+fractionCompleted >= 0.99) {
        fractionCompleted = 0.99;
    }
    return Math.round(+fractionCompleted * 100);
}
exports.useDownloadingModelProgress = useDownloadingModelProgress;
